import React from 'react'

function HomeContentComponent() {
    return (
        <div>
            <div class='text-center '>
                <p className='text-light nav-item-main-head '> <span class='me-5'>M E H A N D I </span> M A L A B A R</p>
                <p class='text-light'>" W H E R E <span class='me-3'></span>  L O V E <span class='me-3'></span> S H I N E S <span class='me-3'></span> I N <span class='me-3'></span> E V E R Y <span class='me-3'></span> H U E  "</p>
            </div>
        </div>
    )
}

export default HomeContentComponent